import React, { useState } from 'react';
import { Button, Grid, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import { Col, Form, Row } from 'react-bootstrap';
import Home from '../home/Home';
import { useEffect } from 'react';
import BillingService from '../../Services/billing/BillingService';
import { getUserId } from '../Utils/Common';
import Snacbar from '../Snacbar';
import HashLoader from "react-spinners/HashLoader";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from "react-router";
import { ToggleButton } from '@mui/material';

const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  border: '1px solid black',
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  // textAlign: 'center',
  color: theme.palette.text.secondary,
  border: '1px solid black',
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: theme.palette.common.black,
    padding: theme.spacing(0.5),
    fontFamily: 'Times New Roman',
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 15,
    color: 'darkblue',
    textAlign: 'center',
    fontFamily: 'Times New Roman',
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
}));

function BillSubmission() {

  const [job_Hidden, setjobBill_Hidden] = useState(true);
  const [radiovalue, setradiovalue] = useState('1');

  const [nonUplodedetails, setnonUplodedetails] = useState([]);
  const [Uplodedetails, setUplodedetails] = useState([]);

  const [BillSubmissionValues, setBillSubmissionValues] = useState({
    jobNo: '',
    billReceivedBy: '',
    billSubmittedBy: '',
    billSubmittedDate: '',
    billSubmittedtime: '',
    SubmitRemarks: '',
  });
  const [consigment, setConsigment] = useState('')
  const [submiteDsa, setSubmiteDsa] = useState(true);
  const [UpdateDsa, setUpdateDsa] = useState(true);
  const [loading, setloading] = useState(false)
  const [NonSubmiteDsa, setNonSubmiteDsa] = useState(true);
  const [Filtereddetails, setFiltereddetails] = useState([]);
  const [Filtereddetails2, setFiltereddetails2] = useState([]);
  const [submite, setSubmite] = useState(false);
  const [Update, setUpdate] = useState(false);
  const [NonSubmite, setNonSubmite] = useState(false);
  const [selected, setSelected] = useState([]);
  const [BillRecivedBy, setBillRecivedBy] = useState([]);
  const [open, setOpen] = useState(false);
  const [severity, setseverity] = useState('');
  const [message, setMessage] = useState('');

  const jobNoChangeHandle = (e) => {
    setBillSubmissionValues({ ...BillSubmissionValues, jobNo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  }
  const billReceivedByChangeHandle = (e) => {
    setBillSubmissionValues({ ...BillSubmissionValues, billReceivedBy: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  }
  const billSubmittedByChangeHandle = (e) => {
    setBillSubmissionValues({ ...BillSubmissionValues, billSubmittedBy: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  }
  const billSubmittedDateChangeHandle = (e) => {
    setBillSubmissionValues({ ...BillSubmissionValues, billSubmittedDate: e.target.value })
  }
  const SubmitRemarksChangeHandle = (e) => {
    setBillSubmissionValues({ ...BillSubmissionValues, SubmitRemarks: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  }
  const RadioChangeHandle = (e) => {
    setradiovalue(e.target.value)
    setjobBill_Hidden(!job_Hidden);
  }

  const getJobNoConsoleNonUpload = () => {
    var consigmnt, importer_iec_no = '';
    if (radiovalue === '1') {
      importer_iec_no = '-1'
      if (BillSubmissionValues.jobNo !== '') { consigmnt = BillSubmissionValues.jobNo }
      else { consigmnt = '-1' }
    }
    else if (radiovalue === '2') {
      consigmnt = '-1'
      if (BillSubmissionValues.jobNo !== '') { importer_iec_no = BillSubmissionValues.jobNo }
      else { importer_iec_no = '-1' }
    }
    let details = { importer_iec_no: importer_iec_no, consignmentNumber: consigmnt, status: '19' }
    BillingService.getJobNoBasedImpCMNonUploadCL(details).then((res) => { setnonUplodedetails(res.data); setFiltereddetails(res.data) });
    BillingService.getJobNoBasedImpCMUploadCL(details).then(res => { setUplodedetails(res.data); setFiltereddetails2(res.data) });
  }

  const getBillSubmission = (val) => {
    BillingService.getBillSubmission(val).then(res => {
      const data = res.data;
      const lastResult = data.map((item) => item);
      var subDate = lastResult[0].subDate;
      const splitDate = subDate.split(' ');
      setBillSubmissionValues({
        ...BillSubmissionValues, billReceivedBy: lastResult[0].recBy, billSubmittedBy: lastResult[0].subBy,
        billSubmittedDate: splitDate[0] + 'T' + splitDate[1], SubmitRemarks: lastResult[0].subRemarks
      })
    });
  }

  const getData = async () => {
    BillingService.getnonAudit('19').then(res => { setnonUplodedetails(res.data); setFiltereddetails(res.data) });
    BillingService.getAudit('19').then(res => { setUplodedetails(res.data); setFiltereddetails2(res.data) });
  }

  const drpdata = async () => {
    BillingService.getEmployeeDetails().then((res) => { setBillRecivedBy(res.data); })
  }

  useEffect(() => {
    setloading(true)
    setTimeout(() => {
      setloading(false)
    }, 1000)
    getData();
    drpdata();
  }, []);

  //tableClick
  const editNonSumitedDetails = (item) => {
    const selectedIndex = selected.indexOf(item.consignmentNumber);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = (selected, item.consignmentNumber);
    }
    setSelected(newSelected);
    setConsigment(item.consignmentNumber);
    setSubmiteDsa(false);
    setNonSubmiteDsa(true);
    setUpdateDsa(true);
    setSubmite(false);
    setUpdate(false);
    setNonSubmite(false);
  }
  const isSelected = (name) => selected.indexOf(name) !== -1;
  const editSumitedDetails = (item) => {
    setConsigment(item.consignmentNumber);
    setSubmiteDsa(true);
    setNonSubmiteDsa(false);
    setUpdateDsa(false);
    setSubmite(false);
    setUpdate(false);
    setNonSubmite(false);
    getBillSubmission(item.consignmentNumber);
  }

  //OnClick

  const Searches = () => {
    getJobNoConsoleNonUpload();
  }

  const validate = () => {
    if (BillSubmissionValues.billReceivedBy !== '') {
      if (BillSubmissionValues.billSubmittedBy !== '') {
        return true;
      }
      else {

        setOpen(true); setseverity('warning'); setMessage('Please Select Received By..!!');
      }
    }
    else {
      setOpen(true); setseverity('warning'); setMessage('Please Select Submited By..!!');
    }
    return false;
  }

  const submitehandle = () => {
    if (validate() === true) {
      setSubmiteDsa(true);
      setSubmite(true);
      var subdate = BillSubmissionValues.billSubmittedDate;
      const splitedate = subdate.split('T')
      let details = {
        consignmentId: consigment, status: '1', recBy: BillSubmissionValues.billReceivedBy, subBy: BillSubmissionValues.billSubmittedBy,
        subDate: splitedate[0] + ' ' + splitedate[1], subRemarks: BillSubmissionValues.SubmitRemarks, createdBy: getUserId()
      }
      BillingService.updateBillSubmission(details).then((res) => {
        const message = res.data.message;
        if (message.toString() === 'SUCCESS') {
          setOpen(true); setseverity('success'); setMessage(message.toString());
        } else {
          setOpen(true); setseverity('error'); setMessage('Submitting Failed ' + message.toString());
        } refresh();
      }).catch(error => {
        setOpen(true); setseverity('error'); setMessage('Submitting Failed ' + error.message); refresh();
      })
    }
  }

  const Updatehandle = () => {
    if (validate() === true) {
      setUpdateDsa(true);
      setUpdate(true);
      var subdate = BillSubmissionValues.billSubmittedDate;
      const splitedate = subdate.split('T')
      let details = {
        consignmentId: consigment, status: '3', recBy: BillSubmissionValues.billReceivedBy, subBy: BillSubmissionValues.billSubmittedBy,
        subDate: splitedate[0] + ' ' + splitedate[1], subRemarks: BillSubmissionValues.SubmitRemarks, createdBy: getUserId()
      }
      BillingService.updateBillSubmission(details).then((res) => {
        const message = res.data.message;
        if (message.toString() === 'SUCCESS') {
          setOpen(true); setseverity('success'); setMessage(message.toString());
        } else {
          setOpen(true); setseverity('error'); setMessage('Updation Failed ' + message.toString());
        } refresh();
      }).catch(error => {
        setOpen(true); setseverity('error'); setMessage('Updation Failed ' + error.message); refresh();
      })
    }
  }

  const NonSubmiteHandle = () => {
    if (validate() === true) {
      setNonSubmiteDsa(true);
      setNonSubmite(true);
      var subdate = BillSubmissionValues.billSubmittedDate;
      const splitedate = subdate.split('T')
      let details = {
        consignmentId: consigment, status: '2', recBy: BillSubmissionValues.billReceivedBy, subBy: BillSubmissionValues.billSubmittedBy,
        subDate: splitedate[0] + ' ' + splitedate[1], subRemarks: BillSubmissionValues.SubmitRemarks, createdBy: getUserId()
      }
      BillingService.updateBillSubmission(details).then((res) => {
        const message = res.data.message;
        if (message.toString() === 'SUCCESS') {
          setOpen(true); setseverity('success'); setMessage(message.toString());
        } else {
          setOpen(true); setseverity('error'); setMessage('Non-Submitting Failed ' + message.toString());
        } refresh();
      }).catch(error => {
        setOpen(true); setseverity('error'); setMessage('Non-Submitting Failed ' + error.message); refresh();
      })
    }
  }

  const refresh = () => {
    setBillSubmissionValues({
      ...BillSubmissionValues, jobNo: '', billReceivedBy: '', billSubmittedBy: '',
      billSubmittedDate: '', billSubmittedtime: '', SubmitRemarks: '',
    });
    setConsigment('')
    setSubmiteDsa(true);
    setNonSubmiteDsa(true);
    setUpdateDsa(true);
    setSubmite(false);
    setUpdate(false);
    setNonSubmite(false);
    getData();
  }

  //handleClose/open
  const handleClose = () => {
    setOpen(false);
  }
  //table search
  const NonAprovaljobSrch = () => {
    return <input className="searchBoxes" style={{ width: '50%' }} onChange={(e) => { NonAprovaljobOnchange(e.target.value) }} />
  }
  const NonAprovaljobOnchange = (searchedVal) => {
    const FilterValues = nonUplodedetails.filter((trns) => {
      return trns.consignmentNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (searchedVal.length < 1) {
      setFiltereddetails(nonUplodedetails)
    } else {
      setFiltereddetails(FilterValues)
    }
  }
  //
  const nonAprovalBillSrch = () => {
    return <input className="searchBoxes" style={{ width: '50%' }} onChange={(e) => { nonAprovalBillOnchange(e.target.value) }} />
  }
  const nonAprovalBillOnchange = (searchedVal) => {
    const FilterValues = nonUplodedetails.filter((trns) => {
      return trns.receiverMailId.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (searchedVal.length < 1) {
      setFiltereddetails(nonUplodedetails)
    } else {
      setFiltereddetails(FilterValues)
    }
  }
  //
  const AprovaljobSrch = () => {
    return <input className="searchBoxes" style={{ width: '50%' }} onChange={(e) => { AprovaljobOnchange(e.target.value) }} />
  }
  const AprovaljobOnchange = (searchedVal) => {
    const FilterValues = Uplodedetails.filter((trns) => {
      return trns.consignmentNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (searchedVal.length < 1) {
      setFiltereddetails2(Uplodedetails)
    } else {
      setFiltereddetails2(FilterValues)
    }
  }
  //
  const AprovalBillSrch = () => {
    return <input className="searchBoxes" style={{ width: '50%' }} onChange={(e) => { AprovalBillOnchange(e.target.value) }} />
  }
  const AprovalBillOnchange = (searchedVal) => {
    const FilterValues = Uplodedetails.filter((trns) => {
      return trns.receiverMailId.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (searchedVal.length < 1) {
      setFiltereddetails2(Uplodedetails)
    } else {
      setFiltereddetails2(FilterValues)
    }
  }


  const navigate = useNavigate();
  const BackBotton = () => {
    navigate('/billaudit');
  }
  return (
    <div >
      <Home /><Snacbar open={open} message={message} severity={severity} onClose={handleClose} />
      <div style={{ paddingLeft: '80px' }}>
        <Row>
          <Col><ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small">
            <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
          <Col xs={11}></Col>
          <Col></Col>
        </Row>
        {loading ?
          <div className="loaderCss">
            <HashLoader
              color={"#296cbc"}
              loading={loading}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
          :
          <Grid container >
            <Grid item xs={3}>
              <ItemPap1 sx={{ height: 650 }}>
                {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt'  size="small" >
                             <ArrowBackIosIcon fontSize='small' style={{ fontSize: '16px',marginLeft:'5px' }}/> </ToggleButton> */}
                <lable style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'red', marginTop: '0.5%', marginBottom: '1%', marginLeft: '18px' }}>Non SubmitBill Job</lable>
                <TableContainer sx={{ maxHeight: 600 }}>
                  <Table stickyHeader className='table table-bordered'>
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell className='p-1'>Sl</StyledTableCell>
                        <StyledTableCell className='p-1'>JobNo {NonAprovaljobSrch()}</StyledTableCell>
                        <StyledTableCell className='p-1'>BillNo {nonAprovalBillSrch()}</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {Filtereddetails.map((item) => {
                        const isItemSelected = isSelected(item.consignmentId)
                        return (
                          <TableRow hover key={item.consignmentId} tabIndex={-1} selected={isItemSelected} onClick={() => editNonSumitedDetails(item)}>
                            <StyledTableCell>{item.serialNumber}</StyledTableCell>
                            <StyledTableCell>{item.consignmentNumber}</StyledTableCell>
                            <StyledTableCell>{item.receiverMailId}</StyledTableCell>
                          </TableRow>)
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </ItemPap1>
            </Grid>
            <Grid item xs={6}>
              <ItemPap sx={{ height: 650 }}>
                <Row><lable style={{ fontFamily: 'Times New Roman', fontSize: '20px', fontWeight: 'bold', color: 'red', marginBottom: '1%' }}>BILL SUBMISSION</lable></Row>

                <Form.Check checked={radiovalue === '1'} style={{ fontFamily: 'Times New Roman', fontWeight: 'bold' }} onChange={RadioChangeHandle} inline label='Job.No' value={'1'} type='radio' />

                <Form.Check checked={radiovalue === '2'} style={{ fontFamily: 'Times New Roman', fontWeight: 'bold' }} onChange={RadioChangeHandle} inline label='Bill.No' value={'2'} type='radio' />

                <center><Form.Control size='sm' value={BillSubmissionValues.jobNo} onChange={jobNoChangeHandle}
                  style={{ fontFamily: 'Times New Roman', width: '320px', marginBottom: '1%', marginTop: '1%', border: '1px solid black', textAlign: 'center', fontWeight: 'bolder' }} /></center>

                <Col><Button variant='contained' style={{ fontFamily: 'Times New Roman', marginBottom: '1%' }} size='small' onClick={Searches}>search</Button></Col>

                <Row>
                  <Col xs={4}><Form.Label className='billingIpTitle'>Bill_ReceivedBy</Form.Label></Col>
                  <Col><Form.Select size='sm' style={{ fontFamily: 'Times New Roman', width: '250px', border: '1px solid black', textAlign: 'center', fontWeight: 'bolder' }}
                    value={BillSubmissionValues.billReceivedBy} onChange={billReceivedByChangeHandle}>
                    <option value={''}></option>
                    {BillRecivedBy.map((item) => (
                      <option value={item.employeeId}>{item.employeeName}</option>
                    ))}
                  </Form.Select>
                  </Col>
                </Row>
                <Row className='mt-2'>
                  <Col xs={4}><Form.Label className='billingIpTitle'>Bill_SubmittedBy</Form.Label></Col>
                  <Col ><Form.Select size='sm' style={{ fontFamily: 'Times New Roman', width: '250px', border: '1px solid black', textAlign: 'center', fontWeight: 'bolder' }}
                    value={BillSubmissionValues.billSubmittedBy} onChange={billSubmittedByChangeHandle}>
                    <option value={''}></option>
                    {BillRecivedBy.map((item) => (
                      <option value={item.employeeId}>{item.employeeName}</option>
                    ))}
                  </Form.Select>
                  </Col>
                </Row>
                <Row className='mt-2'>
                  <Col xs={4}><Form.Label className='billingIpTitle'>Bill_Submitted_Date</Form.Label></Col>
                  <Col><Form.Control size='sm' type='datetime-local' style={{ fontFamily: 'Times New Roman', width: '250px', border: '1px solid black', textAlign: 'center', fontWeight: 'bolder' }}
                    value={BillSubmissionValues.billSubmittedDate} onChange={billSubmittedDateChangeHandle} /></Col>
                </Row>
                <Row className='mt-2'>
                  <Col xs={4}><Form.Label className='billingIpTitle'>Submit_Remarks</Form.Label></Col>
                  <Col><Form.Control size='sm' type='textarea' style={{ fontFamily: 'Times New Roman', width: '250px', border: '1px solid black', textAlign: 'center', fontWeight: 'bolder' }}
                    value={BillSubmissionValues.SubmitRemarks} onChange={SubmitRemarksChangeHandle} /></Col>
                </Row>
                <div className='mt-2'>
                  <Button variant='contained' size='small' style={{ marginRight: '0.5%', fontFamily: 'Times New Roman', }} disabled={submiteDsa} onClick={submitehandle}>{submite ? 'processing..' : 'Submit'}</Button>
                  <Button variant='contained' size='small' style={{ marginRight: '0.5%', fontFamily: 'Times New Roman', }} disabled={UpdateDsa} onClick={Updatehandle} color='secondary'>{Update ? 'Processing...' : 'Update'}</Button>
                  <Button variant='contained' size='small' style={{ marginRight: '0.5%', fontFamily: 'Times New Roman', }} disabled={NonSubmiteDsa} onClick={NonSubmiteHandle} color='info'>{NonSubmite ? 'Processing..' : 'Non_Submited'}</Button>
                  <Button variant='contained' size='small' style={{ marginRight: '0.5%', fontFamily: 'Times New Roman', }} color='error' onClick={refresh}>Refresh</Button>
                </div>
              </ItemPap>
            </Grid>
            <Grid item xs={3}>
              <ItemPap sx={{ height: 650 }}>
                <lable style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'red', marginTop: '0.5%', marginBottom: '1%' }}>Submit Bill Job</lable>
                <TableContainer sx={{ maxHeight: 600 }}>
                  <Table stickyHeader className='table table-bordered'>
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell className='p-1'>Sl</StyledTableCell>
                        <StyledTableCell className='p-1'>JobNo {AprovaljobSrch()}</StyledTableCell>
                        <StyledTableCell className='p-1'>BillNo {AprovalBillSrch()}</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {Filtereddetails2.map((item) => (
                        <StyledTableRow hover key={item.consignmentId} onClick={() => editSumitedDetails(item)}>
                          <StyledTableCell>{item.serialNumber}</StyledTableCell>
                          <StyledTableCell>{item.consignmentNumber}</StyledTableCell>
                          <StyledTableCell>{item.receiverMailId}</StyledTableCell>
                        </StyledTableRow>))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </ItemPap>
            </Grid>
          </Grid>}
      </div>
    </div>
  )
}

export default BillSubmission